
import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Service Pages
const MedicalWebsiteDesignPage = lazy(() => import('../pages/services/medical-website-design/page'));
const MedicalSEOPage = lazy(() => import('../pages/services/medical-seo/page'));
const HealthcarePPCPage = lazy(() => import('../pages/services/healthcare-ppc/page'));
const ReputationManagementPage = lazy(() => import('../pages/services/reputation-management/page'));
const ContentMarketingPage = lazy(() => import('../pages/services/content-marketing/page'));
const SocialMediaMarketingPage = lazy(() => import('../pages/services/social-media-marketing/page'));
const MarketingAutomationPage = lazy(() => import('../pages/services/marketing-automation/page'));
const AILeadCapturePage = lazy(() => import('../pages/services/ai-lead-capture/page'));
const AnalyticsPage = lazy(() => import('../pages/services/analytics-reporting/page'));

// Platform & Company Pages
const AutomationPlatformPage = lazy(() => import('../pages/automation-platform/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BookStrategyCallPage = lazy(() => import('../pages/book-strategy-call/page'));
const SitemapPage = lazy(() => import('../pages/sitemap/page'));

// Industry Pages
const OBGYNMenopausePage = lazy(() => import('../pages/industries/obgyn-menopause/page'));
const PreventiveMedicinePage = lazy(() => import('../pages/industries/preventive-medicine/page'));
const NursePractitionersPage = lazy(() => import('../pages/industries/nurse-practitioners/page'));
const PhysicianAssistantsPage = lazy(() => import('../pages/industries/physician-assistants/page'));
const CardiologyPage = lazy(() => import('../pages/industries/cardiology/page'));
const EndocrinologyPage = lazy(() => import('../pages/industries/endocrinology/page'));
const UrologyPage = lazy(() => import('../pages/industries/urology/page'));
const FunctionalIntegrativePage = lazy(() => import('../pages/industries/functional-integrative/page'));
const LongevityAntiagingPage = lazy(() => import('../pages/industries/longevity-antiaging/page'));
const BHRTHormoneTherapyPage = lazy(() => import('../pages/industries/bhrt-hormone-therapy/page'));
const WellnessCentersPage = lazy(() => import('../pages/industries/wellness-centers/page'));
const MedicalSpasPage = lazy(() => import('../pages/industries/medical-spas/page'));
const PrimaryCarePage = lazy(() => import('../pages/industries/primary-care-prevention/page'));
const ClinicOwnersPage = lazy(() => import('../pages/industries/clinic-owners-directors/page'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  // Services
  { path: '/services/medical-website-design', element: <MedicalWebsiteDesignPage /> },
  { path: '/services/medical-seo', element: <MedicalSEOPage /> },
  { path: '/services/healthcare-ppc', element: <HealthcarePPCPage /> },
  { path: '/services/reputation-management', element: <ReputationManagementPage /> },
  { path: '/services/content-marketing', element: <ContentMarketingPage /> },
  { path: '/services/social-media-marketing', element: <SocialMediaMarketingPage /> },
  { path: '/services/marketing-automation', element: <MarketingAutomationPage /> },
  { path: '/services/ai-lead-capture', element: <AILeadCapturePage /> },
  { path: '/services/analytics-reporting', element: <AnalyticsPage /> },
  // Industries
  { path: '/industries/obgyn-menopause', element: <OBGYNMenopausePage /> },
  { path: '/industries/preventive-medicine', element: <PreventiveMedicinePage /> },
  { path: '/industries/nurse-practitioners', element: <NursePractitionersPage /> },
  { path: '/industries/physician-assistants', element: <PhysicianAssistantsPage /> },
  { path: '/industries/cardiology', element: <CardiologyPage /> },
  { path: '/industries/endocrinology', element: <EndocrinologyPage /> },
  { path: '/industries/urology', element: <UrologyPage /> },
  { path: '/industries/functional-integrative', element: <FunctionalIntegrativePage /> },
  { path: '/industries/longevity-antiaging', element: <LongevityAntiagingPage /> },
  { path: '/industries/bhrt-hormone-therapy', element: <BHRTHormoneTherapyPage /> },
  { path: '/industries/wellness-centers', element: <WellnessCentersPage /> },
  { path: '/industries/medical-spas', element: <MedicalSpasPage /> },
  { path: '/industries/primary-care-prevention', element: <PrimaryCarePage /> },
  { path: '/industries/clinic-owners-directors', element: <ClinicOwnersPage /> },
  // Company
  { path: '/automation-platform', element: <AutomationPlatformPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/book-strategy-call', element: <BookStrategyCallPage /> },
  { path: '/sitemap', element: <SitemapPage /> },
  // 404
  { path: '*', element: <NotFoundPage /> },
];

export default routes;
